<template>
  <div class="main-login">
    <div class="main-login-head">
      <button type="button" class="login-brand" data-track-id="h5.login.brand-home" data-track-text="返回首页" aria-label="返回首页" @click="$router.push('/index')">
        <img src="@/assets/v2/img/index/wiseivy-mark.png" alt="微思学术 Logo">
        <span>微思学术</span>
      </button>
      <div class="login-hero-copy">
        <span>WISETRANS</span>
        <strong>专业翻译，从这里开始</strong>
        <p>安全、高效、便捷的一站式翻译服务</p>
      </div>
    </div>
    <div class="main-login-form">
      <div class="main-login-form-head">
        <div data-track-text="H5密码登录页签" aria-label="H5密码登录页签" @click="headerPassClick" class="main-login-form-pass" :style="active===0?'font-size: 36px;':''">
          密码登录
          <div class="check" :style="active===0?'background: var(--primary-dark);':''"></div>
        </div>
        <div style="width: 1px;height: 32px;background: #999999;margin: 0 41px"></div>
        <div data-track-text="H5快捷登录页签" aria-label="H5快捷登录页签" @click="headerPhoneClick" class="main-login-form-pass" :style="active!==0?'font-size: 36px;':''">
          快捷登录
          <div class="check" :style="active!==0?'background: var(--primary-dark);':''"></div>
        </div>
      </div>
      <div v-show="active===0" class="main-login-form-input">
        <el-form  v-show="active===0" :model="from" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
          <el-form-item label="" prop="username">
            <el-input type="text" v-model="from.username"  placeholder="请输入用户名/邮箱/手机号"/>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input type="password" v-model="from.password"  placeholder="请输入密码"/>
          </el-form-item>
          <el-form-item class="captcha-item" label="" prop="validate">
            <el-input v-model="from.validate" placeholder="请输入四位验证码" style="width: 475px;"></el-input>
            <img
                style="float: right;width: 133px;height: 62px;border: 1px solid #DDDDDD;box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.05);"
                :src="qrcodeUrl" alt="验证码加载失败..."
                data-track-text="刷新图形验证码"
                aria-label="刷新图形验证码"
                @click="getValicode"/>
          </el-form-item>
          <div v-if="messages!==''" style="text-align: center;margin-left: 78px;font-size: 24px;color: #df2525;font-family: Noto Sans S Chinese !important;margin-bottom: -50px;">{{ messages }}</div>
          <el-form-item style="margin-bottom: 0;margin-top: 60px;">
            <div
                style="float: left;cursor:pointer;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #999999;"
                data-track-text="H5忘记密码"
                aria-label="H5忘记密码"
                @click="resetPassword">忘记密码?
            </div>
            <div
                style="float: right;cursor:pointer;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #059669;"
                data-track-text="H5快捷注册"
                aria-label="H5快捷注册"
                @click="toRegister">快捷注册
            </div>
          </el-form-item>
          <el-form-item class="login_button">
            <el-button type="primary" data-track-text="H5密码登录" aria-label="H5密码登录" @click="submitLoginFrom()">登录</el-button>
          </el-form-item>
          <div class="login-ip-title" style="margin-left: 78px;margin-top:-11px;text-align: center;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #999999;">
            {{ ipTitel }}
          </div>
          <div class="third-party-title" style="font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #999999;
text-align: center;
    margin-top: 85px;">
            <hr style="
    width: 280px;
    border-top: 1px solid rgb(203, 203, 203);
    margin-top: 13px;
    position: absolute;
    margin-bottom: 0px;
    left: 50%;
    transform: translate(-50%, -3px);
    z-index: 0;">
            <span style="margin-left: 78px;position: relative;background-color: white;padding: 0px 23px;font-size: 24px;
font-family: Microsoft YaHei;font-weight: 400;color: #999999;line-height: 22px;">第三方登录</span>
          </div>
          <div class="third-party-actions" style="text-align: center;margin-top: 20px;margin-left: 78px;">
            <img src="../../assets/qq_logo.png" alt="" data-track-text="QQ登录" aria-label="QQ登录" width="68" height="68" style="padding: 25px;cursor: pointer;"
                 @click="loginByQQ">
            <img src="../../assets/wx_logo.png" alt="" data-track-text="微信登录" aria-label="微信登录" width="68" height="68" style="padding: 25px;cursor: pointer;"
                 @click="loginByWX">
          </div>

        </el-form>
      </div>
      <div v-show="active!==0" class="main-login-form-input">
        <el-form v-show="active!==0" :model="phoneFrom" :rules="phone_login_rules" ref="phoneLoginRef" label-width="0px" class="demo-ruleForm">
          <el-form-item label="" prop="phone">
            <el-input v-model="phoneFrom.phone"  placeholder="请输入手机号"/>
          </el-form-item>
          <el-form-item class="captcha-item" label="" prop="validate">
            <el-input v-model="phoneFrom.validate" placeholder="请输入四位验证码" style="width: 475px;"></el-input>
            <img
                style="float: right;width: 133px;height: 62px;border: 1px solid #DDDDDD;box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.05);"
                :src="qrcodeUrl" alt="验证码加载失败..."
                data-track-text="刷新图形验证码"
                aria-label="刷新图形验证码"
                @click="getValicode"/>
          </el-form-item>
          <el-form-item class="phone-code-item" label="" prop="phoneValidate">
            <el-input v-model="phoneFrom.phoneValidate" placeholder="请输入六位验证码" style="width: 475px;"></el-input>
            <div class="timeButton" v-show="Verification" data-track-text="H5获取动态密码" aria-label="H5获取动态密码" @click="handleTimeClick">获取动态密码</div>
            <div class="timeButtonClick" v-show="!Verification">{{timers}}秒后重新获取</div>
          </el-form-item>
          <div  v-if="messages!==''" style="text-align: center;margin-bottom: -50px;margin-left: 78px;font-size: 24px;color: #df2525;font-family: Noto Sans S Chinese !important;">{{ messages }}</div>
          <el-form-item style="margin-bottom: 0;margin-top: 60px;">
            <div
                style="float: left;cursor:pointer;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #999999;"
                data-track-text="H5忘记密码"
                aria-label="H5忘记密码"
                @click="resetPassword">忘记密码?
            </div>
            <div
                style="float: right;cursor:pointer;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #059669;"
                data-track-text="H5快捷注册"
                aria-label="H5快捷注册"
                @click="toRegister">快捷注册
            </div>
          </el-form-item>
          <el-form-item class="login_button">
            <el-button type="primary" data-track-text="H5手机号快捷登录" aria-label="H5手机号快捷登录" @click="submitPhoneLoginFrom()">登录</el-button>
          </el-form-item>
          <div class="login-ip-title" style="margin-left: 78px;margin-top:-11px;text-align: center;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #999999;">
            {{ ipTitel }}
          </div>
          <div class="third-party-title" style="font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #999999;
text-align: center;
    margin-top: 85px;">
            <hr style="
    width: 280px;
    border-top: 1px solid rgb(203, 203, 203);
    margin-top: 13px;
    position: absolute;
    margin-bottom: 0px;
    left: 50%;
    transform: translate(-50%, -3px);
    z-index: 0;">
            <span style="margin-left: 78px;position: relative;background-color: white;padding: 0px 23px;font-size: 24px;
font-family: Microsoft YaHei;font-weight: 400;color: #999999;line-height: 22px;">第三方登录</span>
          </div>
          <div class="third-party-actions" style="text-align: center;margin-top: 20px;margin-left: 78px;">
            <img src="../../assets/qq_logo.png" alt="" data-track-text="QQ登录" aria-label="QQ登录" width="68" height="68" style="padding: 25px;cursor: pointer;"
                 @click="loginByQQ">
            <img src="../../assets/wx_logo.png" alt="" data-track-text="微信登录" aria-label="微信登录" width="68" height="68" style="padding: 25px;cursor: pointer;"
                 @click="loginByWX">
          </div>

        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  authServiceClient, checkPhoneRequest,
  checkUserNameRequest,
  getAppIdRequest, loginRequest, phoneCodeRequest, phoneLoginRequest,
  userIpRequest,
  valicodeRequest
} from "@/tools/api/auth-api";

export default {
  name: "Login",
  data() {
    return {
      ipTitel:'',
      timers: 60,
      messages: '',
      qrcodeUrl: undefined,
      active: 0,
      isLogin: false,
      Verification: true,
      phoneFrom: {
        phone: "",
        validate: "",
        phoneValidate: ""
      },
      phone_login_rules: {
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[0-9]{10}$/, message: "请输入合法手机号", trigger: "blur"},
          {validator: this.validatePhone, trigger: 'blur'}
        ],
        validate: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur'}
        ],
        phoneValidate: [
          {validator: this.validatePhoneCode, trigger: 'blur'}
        ]
      },
      from: {
        username: "",
        password: "",
        validate: ""
      },
      rules: {
        username: [
          {required: true, message: '请输入账号/邮箱/手机号', trigger: 'blur'},
          {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'},
          {validator: this.validateName, trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur'}
        ],
        validate: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    this.getValicode();
    this.getUserIp();
  },
  methods: {
    validatePhone(rule, value, callback) {
      let request = checkPhoneRequest;
      request.setPhone(value);
      authServiceClient.checkPhone(request, null).then(res => {
        if (res.getStatus() === 1) {
          callback(new Error('手机号有误'))
          return;
        }
        if (res.getStatus() === 3) {
          callback(new Error('手机号未注册'))
          return;
        }
        if (res.getStatus() === 2) {
          callback(new Error('账号已被冻结'))
          return;
        }
        callback()
      }).catch(err => {
        callback(new Error('校验出错'));
      })
    },
    validatePhoneCode(rule, value, callback) {
      if (!this.isLogin) {
        callback()
        return
      }
      if (value === null || value === undefined || value === "") {
        callback(new Error('请输入手机验证码'))
        return;
      }
      if (value.length > 6 || value.length < 6) {
        callback(new Error('请输入6位手机验证码'))
        return;
      }
      callback()
    },
    headerPassClick() {
      this.active = 0;
    },
    headerPhoneClick() {
      this.active = 1;
    },
    submitLoginFrom() {
      const that = this;
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return false;
        }
        let request = loginRequest;
        request.setUsername(that.from.username);
        request.setPassword(that.from.password);
        request.setValicode(that.from.validate);
        const TOKEN_KEY = 'token';
        const CODE_KEY = 'code';
        let metadata;
        if (localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else if (localStorage.getItem(TOKEN_KEY) && !localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }
        } else if (!localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else {
          metadata = {}
        }
        authServiceClient.userLogin(request, metadata).then(res => {
          if (res.getStatus() === 0) {
            that.$router.push("/index");
            return;
          }
          that.messages = res.getMessage();
          this.getValicode();
        }).catch(err => {
          if (err && err.code === 5) {
            this.$router.push("/h5/login")
          }
        })
      })
    },
    loginByQQ() {
      let request = getAppIdRequest;
      request.setType("qq")
      const CODE_KEY = 'code';
      let metadata;
      if (localStorage.getItem(CODE_KEY)) {
        metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
      } else {
        metadata = {}
      }
      authServiceClient.getAppId(request, metadata).then(res => {
        let state = res.getState();
        if (state === "400") {
          return
        }
        let appId = res.getAppId();
        window.open('https://graph.qq.com/oauth2.0/authorize?client_id=' + appId +
            '&redirect_uri=' + encodeURIComponent("https://wesitrans.com/index") +
            '&response_type=code&scope=get_user_info&state=' + state)
      }).catch(err => {
      })
    },
    loginByWX() {
      let request = getAppIdRequest;
      request.setType("wx")
      const CODE_KEY = 'code';
      let metadata;
      if (localStorage.getItem(CODE_KEY)) {
        metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
      } else {
        metadata = {}
      }
      authServiceClient.getAppId(request, metadata).then(res => {
        let state = res.getState();
        if (state === "400") {
          return
        }
        let appId = res.getAppId();
        window.open('https://open.weixin.qq.com/connect/qrconnect?appid=' + appId +
            '&redirect_uri=' + encodeURIComponent("https://wesitrans.com/index") +
            '&response_type=code&scope=snsapi_login&state=' + state + '#wechat_redirect')
      }).catch(err => {

      })
    },
    resetPassword() {
      this.$router.push('/h5/resetPassword')
    },
    toRegister() {
      this.$router.push("/h5/register")
    },
    getUserIp() {
      authServiceClient.getUserIp(userIpRequest).then(res => {
        this.ipTitel = res.getIpTitle()
      }).catch(err => {
      })
    },
    submitPhoneLoginFrom() {
      this.isLogin = true;
      this.$refs.phoneLoginRef.validate((valid) => {
        if (!valid) {
          return;
        }
        let request = phoneLoginRequest;
        request.setPhone(this.phoneFrom.phone);
        request.setPhoneCode(this.phoneFrom.phoneValidate);
        const TOKEN_KEY = 'token';
        const CODE_KEY = 'code';
        let metadata;
        if (localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else if (localStorage.getItem(TOKEN_KEY) && !localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }
        } else if (!localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else {
          metadata = {}
        }
        authServiceClient.phoneLogin(request, metadata).then(res => {
          if (res.getStatus() === 0) {
            this.$router.push("/index");
            return;
          }
          this.messages = res.getMessage();
          this.getValicode();
          this.isLogin = false;
        }).catch(err => {
          if (err && err.code === 5) {
            this.$router.push("/h5/login")
          }
          this.isLogin = false;
        })
      });
      this.isLogin = false;
    },
    handleTimeClick() {
      this.$refs.phoneLoginRef.validate((valid) => {
        if (!valid) {
          return;
        }
        const that = this;
        let request = phoneCodeRequest;
        request.setCode(this.phoneFrom.validate)
        request.setPhone(this.phoneFrom.phone)
        const CODE_KEY = 'code';
        let metadata;
        if (localStorage.getItem(CODE_KEY)) {
          metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
        } else {
          metadata = {}
        }
        authServiceClient.sendPhoneCode(request, metadata)
            .then(res => {
              if (res.getStatus()) {
                that.messages = "";
                that.Verification = false;
                this.auth_timer = setInterval(() => {
                  that.timers--;
                  if (that.timers <= 0) {
                    that.Verification = true;
                    that.timers = 60;
                    clearInterval(that.auth_timer)
                  }
                }, 1000)
                return;
              }
              that.getValicode();
              that.messages = "验证码错误"
              that.Verification = true;
              that.timers = 60;
            }).catch(err => {
          that.getValicode();
          that.messages = "手机验证码发送失败"
          that.Verification = true;
          that.timers = 60;
        });
      });
    },
    getValicode() {
      const CODE_KEY = 'code';
      let metadata;
      if (localStorage.getItem(CODE_KEY)) {
        metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
      } else {
        metadata = {}
      }
      authServiceClient.getValicode(valicodeRequest, metadata).then(res => {
        this.qrcodeUrl = 'data:image/gif;base64,' + res.toObject().valicodeImage;
      })
    },
    validateName(rule, value, callback) {
      if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
        callback(new Error('用户名不能含有汉字'));
        return;
      }
      if (/.*[`~!#$^&*()=|{}':;',\[\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]+.*$/.test(value)) {
        callback(new Error('用户名不能包含特殊字符'));
        return;
      }
      let request = checkUserNameRequest;
      request.setUsername(value);
      authServiceClient.checkUserName(request, null).then(res => {
        if (res.getStatus() === 1) {
          callback(new Error('账号有误'))
          return;
        }
        if (res.getStatus() === 3) {
          callback(new Error('账号未注册'))
          return;
        }
        if (res.getStatus() === 2) {
          callback(new Error('账号已被冻结'))
          return;
        }
        callback()
      }).catch(err => {
        callback(new Error('校验出错'));
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style lang="less" scoped>
.timeButton {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 45px;
  float: right;
  background-color: #efeded;
  font-size: 21px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  color: #333333;
  display: flex;
  justify-content: center;
}

.timeButtonClick {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 45px;
  float: right;
  background-color: var(--primary-dark);
  font-size: 18px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  display: flex;
  justify-content: center;
  color: #ffffff;
}
.main-login {
  min-width: 765px;
  width: 100%;
  height: 1315px;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;

  .main-login-head {
    width: 100%;
    height: 420px;
    background: url("../../assets/H5/nh.png") no-repeat var(--primary-dark);
    background-position: center;
    background-size: contain;
  }

  .main-login-form {
    margin-top: -71px;
    width: 704px;
    height: 1008px;
    background: #FFFFFF;

    .main-login-form-head {
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 56px;
      text-align: center;
      margin-top: 50px;
      display: flex;
      justify-content: center;
      align-items: center;

      .main-login-form-pass {
        cursor: pointer;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;

        .check {
          width: 64px;
          height: 4px;
          margin-top: 15px;
        }
      }
    }

    .main-login-form-input {
      margin-top: 61px;
      width: 625px;
      display: flex;
      justify-content: center;

      /deep/ .demo-ruleForm {
        .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
          height: 65px;
          border: 1px solid #FBAFAF;
          box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
          border-radius: 3px;
        }

        .el-button--primary {
          width: 624px;
          height: 70px;
          background: var(--primary-dark);
          border-radius: 3px;
          margin-top: 31px;
          font-size: 30px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #FFFFFF;
        }

        .el-form-item__error {
          color: #F56C6C;
          font-size: 20px;
          line-height: 1;
          padding-top: 4px;
          position: absolute;
          top: 100%;
          left: 0;
        }

        .el-form-item {
          margin-bottom: 31px;
        }

        .el-form-item__content {
          margin-left: 76px !important;
        }

        .el-input {
          height: 65px;
          width: 625px;

          .el-input__inner {
            height: 65px;
            border: 1px solid #DDDDDD;
            box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
            border-radius: 3px;
            font-size: 24px;
          }
        }
      }
    }
  }
}

/* 首页视觉体系下的响应式登录页 */
.main-login {
  min-width: 0;
  min-height: 100vh;
  height: auto;
  padding-bottom: 40px;
  box-sizing: border-box;
  background: radial-gradient(circle at 86% 8%, #dbeaff 0, transparent 32%), #f3f7fb;

  .main-login-head {
    position: relative;
    width: 100%;
    min-width: 0;
    height: 270px;
    overflow: hidden;
    background-image: linear-gradient(90deg, var(--primary-alpha-94), var(--primary-alpha-76)), url("../../assets/v2/img/index/banner-img1.jpg");
    background-position: center;
    background-size: cover;
  }

  .login-brand {
    position: absolute;
    top: 18px;
    left: max(20px, calc((100% - 520px) / 2));
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 12px;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    border: 0;
    border-radius: 9px;
    background: rgba(255, 255, 255, .14);
    cursor: pointer;
  }

  .login-brand img { width: 32px; height: 32px; object-fit: contain; border-radius: 6px; }
  .login-hero-copy { position: absolute; left: 50%; bottom: 52px; width: min(520px, calc(100% - 40px)); color: #fff; transform: translateX(-50%); }
  .login-hero-copy > span { display: block; margin-bottom: 8px; font-size: 11px; font-weight: 700; letter-spacing: 3px; opacity: .8; }
  .login-hero-copy strong { display: block; font-size: 30px; line-height: 42px; }
  .login-hero-copy p { margin: 7px 0 0; font-size: 14px; opacity: .85; }

  .main-login-form {
    position: relative;
    z-index: 2;
    width: min(520px, calc(100% - 32px));
    height: auto;
    min-height: 650px;
    margin: -34px auto 0;
    padding: 28px 32px 32px;
    box-sizing: border-box;
    border: 1px solid #e0e8f0;
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 18px 45px var(--primary-alpha-14);

    .main-login-form-head { margin-top: 0; color: #526172; font-size: 18px; line-height: 28px; }
    .main-login-form-head > div:nth-child(2) { height: 22px !important; margin: 0 28px !important; background: #d7e0e8 !important; }
    .main-login-form-pass { font-size: 18px !important; }
    .main-login-form-pass .check { width: 42px; height: 3px; margin-top: 9px; border-radius: 3px; }
    .main-login-form-input { width: 100%; margin: 28px auto 0; display: block; }
  }

  .main-login-form-input /deep/ .demo-ruleForm { width: 100%; }
  .main-login-form-input /deep/ .el-form-item { margin-bottom: 20px; }
  .main-login-form-input /deep/ .el-form-item__content { margin-left: 0 !important; line-height: normal; }
  .main-login-form-input /deep/ .el-input { width: 100% !important; height: 48px; }
  .main-login-form-input /deep/ .el-input__inner { height: 48px !important; padding: 0 15px; border: 1px solid #d7e1eb; border-radius: 8px; background: #f9fbfd; box-shadow: none; font-size: 15px; }
  .main-login-form-input /deep/ .el-input__inner:focus { border-color: var(--primary); box-shadow: 0 0 0 3px var(--primary-alpha-10); }
  .main-login-form-input /deep/ .el-form-item__error { font-size: 12px; }
  .main-login-form-input /deep/ .captcha-item .el-form-item__content,
  .main-login-form-input /deep/ .phone-code-item .el-form-item__content { display: flex; gap: 10px; }
  .main-login-form-input /deep/ .captcha-item .el-input,
  .main-login-form-input /deep/ .phone-code-item .el-input { flex: 1; min-width: 0; }
  .main-login-form-input /deep/ .captcha-item img { flex: 0 0 108px; width: 108px !important; height: 46px !important; float: none !important; object-fit: cover; border-radius: 7px; cursor: pointer; }
  .main-login-form-input /deep/ .el-form-item[style*="margin-top"] { margin-top: 22px !important; }
  .main-login-form-input /deep/ .el-form-item[style*="margin-top"] .el-form-item__content > div { font-size: 14px !important; }
  .main-login-form-input /deep/ .login_button .el-button--primary { width: 100%; height: 48px; margin-top: 6px; border: 0; border-radius: 8px; background: var(--primary-gradient); box-shadow: 0 8px 18px var(--primary-alpha-20); font-size: 17px; }
  .timeButton, .timeButtonClick { flex: 0 0 118px; width: 118px; height: 48px; padding: 0; float: none; align-items: center; border-radius: 8px; font-size: 13px; }
}

@media (max-width: 600px) {
  .main-login { padding-bottom: 24px; }
  .main-login .main-login-head { height: 250px; }
  .main-login .login-brand { top: 12px; left: 12px; padding: 5px 8px; }
  .main-login .login-brand span { display: none; }
  .main-login .login-hero-copy {
    left: 20px;
    right: 20px;
    bottom: 54px;
    width: auto;
    box-sizing: border-box;
    transform: none;
    overflow: visible;
  }
  .main-login .login-hero-copy > span { margin-bottom: 6px; font-size: 10px; letter-spacing: 2px; }
  .main-login .login-hero-copy strong { font-size: 22px; line-height: 31px; white-space: normal; }
  .main-login .login-hero-copy p { margin-top: 5px; font-size: 12px; line-height: 18px; }
  .main-login .main-login-form { width: calc(100% - 24px); margin: -32px auto 0; padding: 24px 20px 28px; border-radius: 16px; }
  .main-login .main-login-form .main-login-form-head > div:nth-child(2) { margin: 0 18px !important; }
}
</style>
<style lang="less">
.main-login {
  .main-login-form-input .demo-ruleForm { width: 100% !important; margin-right: auto !important; margin-left: auto !important; }
  .main-login-form .main-login-form-input .demo-ruleForm .el-form-item .el-form-item__content {
    width: 100% !important;
    margin-left: 0 !important;
  }
  .main-login-form-input .el-form-item { margin-bottom: 20px !important; }
  .main-login-form-input .el-form-item__content { margin-left: 0 !important; line-height: normal !important; }
  .main-login-form-input .el-input { width: 100% !important; height: 48px !important; }
  .main-login-form-input .el-input__inner { height: 48px !important; padding: 0 15px !important; border: 1px solid #d7e1eb !important; border-radius: 8px !important; background: #f9fbfd !important; box-shadow: none !important; font-size: 15px !important; }
  .main-login-form-input .el-input__inner:focus { border-color: var(--primary) !important; box-shadow: 0 0 0 3px var(--primary-alpha-10) !important; }
  .main-login-form-input .el-form-item__error { font-size: 12px !important; }
  .main-login-form-input .captcha-item .el-form-item__content,
  .main-login-form-input .phone-code-item .el-form-item__content { display: flex !important; gap: 10px; }
  .main-login-form-input .captcha-item .el-input,
  .main-login-form-input .phone-code-item .el-input { flex: 1; min-width: 0; }
  .main-login-form-input .captcha-item img { flex: 0 0 108px; width: 108px !important; height: 46px !important; float: none !important; object-fit: cover; border-radius: 7px; }
  .main-login-form-input .login_button .el-button--primary { width: 100% !important; height: 48px !important; margin-top: 6px !important; border: 0 !important; border-radius: 8px !important; background: var(--primary-gradient) !important; box-shadow: 0 8px 18px var(--primary-alpha-20); font-size: 17px !important; }
  .main-login-form-input .el-form-item[style*="margin-top"] { margin-top: 22px !important; }
  .main-login-form-input .el-form-item[style*="margin-top"] .el-form-item__content > div { font-size: 14px !important; }
  .main-login-form-input [style*="margin-left: 78px"],
  .main-login-form-input [style*="margin-left:78px"] { margin-left: 0 !important; }
  .main-login-form-input .login-ip-title {
    margin: 2px 0 0 !important;
    color: #8a96a3 !important;
    font-size: 14px !important;
    line-height: 20px;
  }
  .main-login-form-input .third-party-title {
    position: relative;
    margin-top: 38px !important;
    color: #8a96a3 !important;
    font-size: 14px !important;
    line-height: 20px;
  }
  .main-login-form-input .third-party-title hr {
    width: 188px !important;
    margin-top: 10px !important;
  }
  .main-login-form-input .third-party-title span {
    margin-left: 0 !important;
    padding: 0 15px !important;
    font-size: 14px !important;
    line-height: 20px !important;
  }
  .main-login-form-input .third-party-actions {
    margin: 18px 0 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 28px;
  }
  .main-login-form-input .third-party-actions img {
    width: 42px !important;
    height: 42px !important;
    padding: 0 !important;
    object-fit: contain;
  }
}
</style>
